// This file is auto-generated during build. Do not edit.

export interface Scan2SellConfig {
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_INVENTORY_API: string;
  VITE_JAMS_QR_API: string; // env-only
  VITE_UPLOAD_SERVICE_API_BASE_URL: string;
  VITE_COMPONENTS_BUCKET_NAME: string;
}

export const config: Scan2SellConfig = {
  VITE_CDN_URL: "https://d30yj9jglnh5th.cloudfront.net",
  VITE_CDN_ID: "EVADZECPUWBGD",
  VITE_JAMS_BACKEND_URL: "https://a32xerzekl.execute-api.us-west-2.amazonaws.com/dev",
  VITE_JAMS_FRONTEND_URL: "https://jams.admin.dev.sodasoft.io",
  VITE_INVENTORY_API: "https://xvu8b6jyrf.execute-api.us-west-2.amazonaws.com/dev",
  VITE_JAMS_QR_API: "https://yzk10abu3d.execute-api.us-west-2.amazonaws.com/dev2/qr",
  VITE_UPLOAD_SERVICE_API_BASE_URL: "https://y0acg7z66k.execute-api.us-west-2.amazonaws.com",
  VITE_COMPONENTS_BUCKET_NAME: "jazel-lightning-components",
};
